import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
}

export function formatDate(date) {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date));
}

export function generateId() {
  return Math.random().toString(36).substring(2, 15);
}

export const OPTION_TYPES = [
  { value: 'text', label: 'Text Input', icon: 'Type' },
  { value: 'number', label: 'Number Input', icon: 'Hash' },
  { value: 'dropdown', label: 'Dropdown', icon: 'ChevronDown' },
  { value: 'radio', label: 'Radio Buttons', icon: 'Circle' },
  { value: 'button', label: 'Text Buttons', icon: 'Square' },
  { value: 'checkbox', label: 'Checkbox', icon: 'CheckSquare' },
  { value: 'color_swatch', label: 'Color Swatch', icon: 'Palette' },
  { value: 'image_swatch', label: 'Image Swatch', icon: 'Image' },
  { value: 'swatch_dropdown', label: 'Swatch Dropdown', icon: 'SwatchBook' },
  { value: 'cards', label: 'Cards', icon: 'LayoutGrid' },
  { value: 'date', label: 'Date Picker', icon: 'Calendar' },
  { value: 'file', label: 'File Upload', icon: 'Upload' },
];

export const PRICE_TYPES = [
  { value: 'fixed', label: 'Fixed Amount (+$)' },
  { value: 'percentage', label: 'Percentage (+%)' },
  { value: 'per_quantity', label: 'Per Quantity' },
];

export const DEFAULT_COLORS = [
  '#000000', '#FFFFFF', '#EF4444', '#F97316', '#EAB308',
  '#22C55E', '#14B8A6', '#3B82F6', '#8B5CF6', '#EC4899',
  '#78716C', '#1E3A5F', '#7C2D12', '#166534',
];
